const system = (ajaxinstance) => {
  const api = {}

  api.getSysCountryCode = () => ajaxinstance({
    method: 'GET',
    url: '/v1/system/country-code',
  })

  api.getUserInfo = token => ajaxinstance({
    method: 'GET',
    url: `/activity/userinfo/${token}`,
  })

  return api
}

export default system
